import { combineReducers } from 'redux';

const masterInitialState = {
  list: null,
  loadStatus: 0,
  didLoadAll: false,
  query: {
    time: '',
    tab: '',
    sub: '',
    isTeam: '',
    level: '',
    sort: 0,
    size: 20,
  },
};

const detailInitialState = {
  loadStatus: 0,
};

function masterReducer(state = masterInitialState, action) {
  switch (action.type) {
    case 'LOAD_TEAM_MEMBER_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_TEAM_MEMBER_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(user => user.uid);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    case 'RESET_LOAD_TEAM_MEMBER_LIST': {
      return {
        ...masterInitialState,
        input: {
          ...masterInitialState.input,
          ...action.input,
        },
      };
    }

    default:
      return state;
  }
}

function detailsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_TEAM_MEMBER_DETAIL': {
      const { uid } = action;

      return {
        ...state,
        [uid]: {
          ...(state[uid] || detailInitialState),
          loadStatus: 1,
        },
      };
    }

    case 'LOAD_TEAM_MEMBER_DETAIL_COMPLETION': {
      const { uid, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [uid]: {
          ...(state[uid] || detailInitialState),
          loadStatus: 2,
        },
      };
    }

    default:
      return state;
  }
}

function usersReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_TEAM_MEMBER_DETAIL_COMPLETION': {
      const { uid, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [uid]: data,
      };
    }

    case 'LOAD_TEAM_MEMBER_LIST_COMPLETION': {
      if (action.error) {
        return state;
      }

      const users = action.list.reduce(
        (obj, user) => {
          const uid = user.uid;

          if (uid) {
            obj[uid] = { ...obj[uid], ...user };
          }
          return obj;
        },
        { ...state }
      );

      return users;
    }

    default:
      return state;
  }
}

export default combineReducers({
  master: masterReducer,
  details: detailsReducer,
  users: usersReducer,
});
